import * as React from "react";
import { observer } from "mobx-react";
import { useContext } from "react";
import { ContactViewStoreContext } from "../../context/store";
import { Form, Button } from "antd";
import { RouteComponentProps } from "react-router-dom";
import { PhoneNumberFormItem } from "../molecules/PhoneNumberFormItem";
import { EmailFormItem } from "../molecules/EmailFormItem";
import { PostalCodeFormItem } from "../molecules/PostalCodeFormItem";
import { AddressFormItem } from "../molecules/AddressFormItem";
import { ArrowLink } from "../atoms/ArrowLink";
import { medium } from "../../style/button";
import { FixedFooter } from "../atoms/FixedFooter";
import { css } from "@emotion/core";
import { Footer } from "../organisms/Footer";

export const InquiryContact2 = observer(({ history }: RouteComponentProps) => {
  const store = useContext(ContactViewStoreContext);

  return (
    <div>
      <h2
        css={css`
          @media (min-width: 576px) {
            text-align: center;
          }
        `}
      >
        資料送付先とご連絡先をご記入ください
      </h2>

      <Form
        labelCol={{ xs: { span: 24 }, sm: { span: 8 } }}
        wrapperCol={{ xs: { span: 24 }, sm: { span: 12 } }}
      >
        <PhoneNumberFormItem />
        <EmailFormItem />
        <PostalCodeFormItem />
        <AddressFormItem />
      </Form>

      <Footer />

      <FixedFooter>
        <button
          css={medium}
          onClick={() => {
            if (!store.hasAdvancedContactInfo) {
              alert("すべての項目を埋めてください");
              return;
            }

            if (!store.hasValidEmail) {
              alert("メールアドレスの書式を確認してください");
              return;
            }

            history.push("/inquiry/order");
          }}
        >
          OK
        </button>
        <ArrowLink to="/inquiry/contact1" direction="left" />
      </FixedFooter>
    </div>
  );
});
